export const DEFAULT_ALERT_TITLE: string = 'Error Notification',
    DEFAULT_ALERT_CLOSE_BTN_LABEL: string = 'Okay, thanks',
    DEFAULT_ALERT_ERROR_MESSAGE: string = 'An unexpected error occurred.',
    DEFAULT_SPINNER_TITLE: string = 'Working...';
